<template>
  <button class="hover:text-red" @click="masquerade">
    <EyeIcon />
  </button>
</template>

<script>
import EyeIcon from "../../icons/EyeIcon.vue";
export default {
  name: "MasqueradeAsUser",
  components: { EyeIcon },
  props: {
    user: {
      type: Object,
      required: true,
    }
  },
  methods: {
    async masquerade() {
      try {
        const data = await axios.post('/api/admin/masquerade/' + this.user.id);
        if (data.data.success) {
          this.$toasted.show('Successfully masqueraded as user. Your page will refresh in 3 seconds.');

          setTimeout(() => {
            // noinspection JSValidateTypes
            window.location = '/';
          }, 3000);
        }
      } catch(e) {
        // do something here to notify user that we failed to masquerade
        this.$toasted.error('Error: unable to masquerade at this time.');
      }
    }
  }
}
</script>

<style scoped>

</style>